/*
  assets/onze-ballers-sckr.js
  Center-mode rail met oneindige loop voor sections/onze-ballers-sckr.liquid.

  Twee taken:
  1. De kaartenset wordt 3x of 5x gekloond, zodat je in beide richtingen door kunt
     blijven scrollen. Bij het passeren van een setbreedte springt scrollLeft een
     hele set terug of vooruit. Omdat de inhoud identiek is, is die sprong onzichtbaar.
  2. De kaart die het midden passeert krijgt `.is-active`; het schalen zit in CSS.

  Bij het laden staat de eerste kaart van de middelste set gecentreerd, dus er is
  meteen aan beide zijden een buurkaart zichtbaar (wens Hugo 09-09-2026).

  Waarom JS en niet puur CSS: meeschalen op scrollpositie vraagt
  `animation-timeline: view()`, en dat ontbreekt in Firefox.

  Waarom geen inline <script>: die draait niet opnieuw als de theme editor de
  sectie-HTML vervangt (LEARNINGS 18-07-2026). Vandaar `shopify:section:load`.

  Alleen actief onder 1024px. Daarboven is het een vast grid van 3 en worden de
  klonen verwijderd — anders zou je elke speler drie keer in het grid zien.
*/
(function () {
  'use strict';

  var RAIL = '[data-obs-rail]';
  var CARD = '[data-obs-card]';
  var ORIGINAL = '[data-obs-card]:not([data-obs-clone])';
  var mq = window.matchMedia('(max-width: 1023px)');

  var states = new WeakMap();

  /* ---------- klonen ---------- */

  function makeClone(card) {
    var clone = card.cloneNode(true);
    clone.setAttribute('data-obs-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    // De editor mag een kloon nooit als bewerkbaar block zien.
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) {
      n.removeAttribute('data-shopify-editor-block');
    });
    // Alleen het origineel mag eager laden.
    clone.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('loading', 'lazy');
      img.removeAttribute('fetchpriority');
    });
    return clone;
  }

  function buildClones(rail, originals, copies, middle) {
    function set() {
      var frag = document.createDocumentFragment();
      originals.forEach(function (card) { frag.appendChild(makeClone(card)); });
      return frag;
    }
    for (var before = 0; before < middle; before++) {
      rail.insertBefore(set(), rail.firstChild);
    }
    for (var after = 0; after < copies - 1 - middle; after++) {
      rail.appendChild(set());
    }
  }

  function stripClones(rail) {
    rail.querySelectorAll('[data-obs-clone]').forEach(function (n) { n.remove(); });
  }

  /* ---------- meten ---------- */

  function centerOffset(rail, card) {
    return card.offsetLeft + card.offsetWidth / 2 - rail.clientWidth / 2;
  }

  function measure(rail, state) {
    var cards = rail.querySelectorAll(CARD);
    if (cards.length < 2) return false;
    // Afstand tussen twee kaartranden = kaartbreedte + tussenruimte.
    state.step = cards[1].offsetLeft - cards[0].offsetLeft;
    state.setWidth = state.step * state.count;
    state.loopStart = centerOffset(rail, cards[state.middle * state.count]);
    return state.setWidth > 0;
  }

  /* ---------- loop ---------- */

  function keepInBand(rail, state) {
    var x = rail.scrollLeft;
    if (x < state.loopStart - state.setWidth) rail.scrollLeft = x + state.setWidth;
    else if (x > state.loopStart + state.setWidth) rail.scrollLeft = x - state.setWidth;
  }

  function activate(rail) {
    if (states.has(rail)) return;

    var originals = Array.prototype.slice.call(rail.querySelectorAll(ORIGINAL));
    if (!originals.length) return;

    var state = { count: originals.length, raf: 0 };

    // Bij weinig spelers meer kopieën, zodat een snelle veeg nooit buiten de buffer valt.
    var copies = state.count >= 5 ? 3 : 5;
    state.middle = Math.floor(copies / 2);
    state.loop = state.count >= 2;

    if (state.loop) {
      buildClones(rail, originals, copies, state.middle);
      if (measure(rail, state)) {
        rail.scrollLeft = state.loopStart;
      } else {
        state.loop = false;
        stripClones(rail);
      }
    }

    // Alleen de kaart die de middelste 2% van de rail raakt telt als actief.
    state.io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-active', entry.isIntersecting);
      });
    }, { root: rail, rootMargin: '0px -49% 0px -49%', threshold: 0 });

    rail.querySelectorAll(CARD).forEach(function (card) { state.io.observe(card); });

    if (state.loop) {
      state.onScroll = function () {
        if (state.raf) return;
        state.raf = requestAnimationFrame(function () {
          state.raf = 0;
          keepInBand(rail, state);
        });
      };
      rail.addEventListener('scroll', state.onScroll, { passive: true });
    }

    states.set(rail, state);
  }

  function deactivate(rail) {
    var state = states.get(rail);
    if (!state) return;
    if (state.io) state.io.disconnect();
    if (state.onScroll) rail.removeEventListener('scroll', state.onScroll);
    if (state.raf) cancelAnimationFrame(state.raf);
    stripClones(rail);
    rail.querySelectorAll(CARD).forEach(function (card) {
      card.classList.remove('is-active');
    });
    rail.scrollLeft = 0;
    states.delete(rail);
  }

  /* ---------- aansturing ---------- */

  function sync(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(RAIL).forEach(function (rail) {
      if (mq.matches) activate(rail);
      else deactivate(rail);
    });
  }

  function init() { sync(document); }

  function remeasure() {
    document.querySelectorAll(RAIL).forEach(function (rail) {
      var state = states.get(rail);
      if (!state || !state.loop) return;
      var centered = rail.scrollLeft - state.loopStart;
      if (measure(rail, state)) rail.scrollLeft = state.loopStart + centered;
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(remeasure, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Breakpoint-wissel: rail <-> grid.
  if (mq.addEventListener) mq.addEventListener('change', init);
  else if (mq.addListener) mq.addListener(init);

  // Theme editor.
  document.addEventListener('shopify:section:load', function (e) { sync(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll(RAIL).forEach(deactivate);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target.closest ? e.target.closest(CARD) : null;
    if (!card || !mq.matches) return;
    var rail = card.closest(RAIL);
    var state = rail && states.get(rail);
    if (rail && state) rail.scrollLeft = centerOffset(rail, card);
  });
})();
